import NavBar from "./components/NavBar";
import Hero from "./components/BlendedHero";
import Staff from "./components/Staff";
import Services from "./components/Services";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import Work from "./components/Work";
import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function App() {
  const inProduction = false;

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline();
    gsap.from(".hero-title", {
      scrollTrigger: {
        trigger: ".hero-title",
        start: "top bottom"
      },
      x: 50,
      opacity: 0,
      duration: 1.6
    });
    gsap.from(".hero-subtitle", {
      scrollTrigger: {
        trigger: ".hero-subtitle",
        start: "top bottom"
      },
      x: -60,
      opacity: 0,
      duration: 1.6
    });
    gsap.from(".about-us-title", {
      scrollTrigger: {
        trigger: ".about-us-title",
        start: "top bottom"
      },
      y: -60,
      opacity: 0,
      duration: 1
    });
    gsap.from(".our-work-title", {
      scrollTrigger: {
        trigger: ".our-work-title",
        start: "top bottom"
      },
      y: -60,
      opacity: 0,
      duration: 1
    });
    gsap.from(".staff-card", {
      scrollTrigger: {
        trigger: ".staff-card",
        start: "bottom bottom"
      },
      x: -40,
      opacity: 0,
      duration: 0.45,
      stagger: 0.1
    });
    gsap.from(".service-card", {
      scrollTrigger: {
        trigger: ".service-card",
        start: "bottom bottom"
      },
      x: -40,
      opacity: 0,
      duration: 0.45,
      stagger: 0.1
    });
    gsap.from(".footer", {
      scrollTrigger: {
        trigger: ".footer",
        start: "top bottom"
      },
      y: 100,
      opacity: 0,
      duration: 1
    });
  });
  return (
    <>
      <NavBar
        homeURL={
          inProduction ? "localhost:3000" : "https://www.medicare-hospital.com"
        }
      />
      <Hero />
      <AboutUs />
      <Staff />
      <Services />
      <Footer />
    </>
  );
}

export default App;
